<template lang="pug">
div
  v-btn(color="green" class="ma-2 white--text" @click="showCreateForm")
    | Crear usuario
    v-icon(right dark) mdi-account-plus
  confirm-dialog(
    v-model="showDeleteModal"
    @confirm="confirmDelete"
    :loading="loadingAction"
    :message="'El usuario no puede eliminarse si tiene folios, consultas VUR o documentos relacionados.'")
  v-card(class="mt-2")
    v-card-title
      v-text-field(
        ref="inputSearch"
        v-model="search"
        label="Buscar usuarios"
        single-line
        hide-details
        :append-icon="`${search === '' ? 'mdi-magnify' : 'mdi-trash-can-outline'}`"
        @click:append="search = ''")
      v-divider(class="mx-4" inset vertical)
      v-btn(:loading="loadingUsers" color="info" dark class="mr-2" @click="fetchUsers") Refrescar elementos
    v-data-table(
      :headers="headers"
      :items="users"
      :loading="loadingUsers"
      loading-text="Cargando usuarios... Por favor espere"
      hide-default-footer
      :page.sync="page"
      disable-pagination)
      template(v-slot:item.id="{ item }")
        b {{ users.map(function(x) { return x.id; }).indexOf(item.id) + (pageSize * (page - 1) + 1) }}
      template(v-slot:item.is_active="{ item }")
        v-icon(:color="item.is_active ? 'green' : 'red'") {{ item.is_active ? 'mdi-check-circle' : 'mdi-close-circle' }}
      template(v-slot:item.is_superuser="{ item }")
        v-icon(:color="item.is_superuser ? 'green' : 'grey'") {{ item.is_superuser ? 'mdi-shield-account' : 'mdi-account' }}
      template(v-slot:item.permissions="{ item }")
        v-chip(v-for="permission in item.permissions" :key="permission" small class="ma-1") {{ permission }}
      template(v-slot:item.options="{ item }")
        v-tooltip(top)
          template(v-slot:activator="{ on, attrs }")
            v-btn(color="gray" icon @click="showEditForm(item.id)" v-bind="attrs" v-on="on")
              v-icon mdi-pencil
          span Editar usuario
        v-tooltip(top v-if="item.email !== email")
          template(v-slot:activator="{ on, attrs }")
            v-btn(color="gray" icon @click="initDelete(item.id)" v-bind="attrs" v-on="on")
              v-icon mdi-trash-can
          span Eliminar usuario
    v-divider
    v-row(class="mx-5 mt-2")
      v-col(cols="4" sm="3")
        v-select(v-model="pageSize" :items="pageSizes" label="Items por página" @change="handlePageSizeChange")
      v-spacer
      v-col(cols="12" sm="9")
        v-pagination(
          v-model="page"
          :length="totalPages"
          total-visible="7"
          next-icon="mdi-menu-right"
          prev-icon="mdi-menu-left"
          @input="handlePageChange")
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import debounce from 'debounce';
import ConfirmDialog from '@/components/ui/ConfirmDialog';

export default {
  name: 'UsersView',

  components: { ConfirmDialog },

  data: () => ({
    page: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50],
    search: '',
    showDeleteModal: false,
    targetUserId: null,
    loadingAction: false,
    headers: [
      { text: '#', align: 'start', filterable: false, value: 'id' },
      { text: 'Nombre', value: 'full_name' },
      { text: 'Correo', value: 'email' },
      { text: 'Activo', value: 'is_active', align: 'center' },
      { text: 'Superusuario', value: 'is_superuser', align: 'center' },
      { text: 'Permisos', value: 'permissions' },
      { text: 'Opciones', value: 'options', sortable: false },
    ],
  }),

  computed: {
    ...mapState('auth', ['email']),
    ...mapState('users', ['users', 'totalPages', 'loadingUsers', 'usersChanged']),
  },

  watch: {
    usersChanged() {
      this.fetchUsers();
    },
    search(newValue) {
      if (newValue.length >= 3 || newValue.length === 0) this.debounceInput();
    },
  },

  async mounted() {
    await this.fetchUsers();
  },

  methods: {
    ...mapMutations('ui', ['CHANGE_VALUE', 'SET_DIALOG_CONTENT', 'SET_DIALOG_TITLE', 'TOGGLE_DIALOG']),
    ...mapActions('users', ['deleteUser', 'getUserDetail', 'getUsers']),
    async fetchUsers() {
      await this.getUsers({ pageSize: this.pageSize, page: this.page, searchQuery: this.search });
    },
    debounceInput: debounce(async function () {
      this.page = 1;
      await this.fetchUsers();
      this.$refs.inputSearch.focus();
    }, 500),
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchUsers();
    },
    handlePageChange(value) {
      this.page = value;
      this.fetchUsers();
    },
    openForm(user = null) {
      this.CHANGE_VALUE({ varName: 'modalWidth', value: '50%' });
      this.CHANGE_VALUE({ varName: 'showModalOptions', value: false });
      this.CHANGE_VALUE({
        varName: 'currentProperties',
        value: { user, currentUserEmail: this.email },
      });
      this.SET_DIALOG_CONTENT('UserForm');
      this.SET_DIALOG_TITLE(user ? 'Editar usuario' : 'Crear usuario');
      this.TOGGLE_DIALOG(true);
    },
    showCreateForm() {
      this.openForm();
    },
    async showEditForm(userId) {
      const user = await this.getUserDetail(userId);
      if (user) this.openForm(user);
    },
    initDelete(userId) {
      this.targetUserId = userId;
      this.showDeleteModal = true;
    },
    async confirmDelete() {
      this.loadingAction = true;
      const result = await this.deleteUser(this.targetUserId);
      if (result.deleted) {
        this.showDeleteModal = false;
        this.targetUserId = null;
        await this.fetchUsers();
      }
      this.loadingAction = false;
    },
  },
};
</script>
